export default () => {
    let token = localStorage.getItem('token');
    return {headers: { Authorization: `Bearer ${token}` }};
};
